import React from 'react';
import { Icon } from '@sizeid/commons/components/SvgImage';

import Arrow from './styled/Arrow';
import { ArrowProps } from './types';

export const NextArrow: React.FC<ArrowProps> = props => (
  <Arrow className={props.className} onClick={props.onClick} next>
    <Icon image="arrow" rotation={180} size="12px" />
  </Arrow>
);

export const PrevArrow: React.FC<ArrowProps> = props => (
  <Arrow className={props.className} onClick={props.onClick}>
    <Icon image="arrow" size="12px" />
  </Arrow>
);
